import { computed, ref, toRaw } from 'vue'
import { flow, head, last, length, map, split, startsWith } from 'ramda'
import { readFile, s3ListKeys } from './s3-api'

const names = ref(null)

const orderNumberToStorage = orderNumber => orderNumber.replace(' ', '_')

const orderDirectory = ({ orderNumber, accessCode }) =>
  `${orderNumberToStorage(orderNumber)}-${accessCode}/`

const getNames = async ({ orderNumber, accessCode }) => {
  const prefix = orderDirectory({ orderNumber, accessCode })
  try {
    const keys = await s3ListKeys(prefix)
    return length(keys) ? map(({ Key }) => Key.split('/')[1], keys) : null
  } catch (error) {
    return null
  }
}

export const loadOrder = async ({ orderNumber, accessCode }) => {
  names.value = await getNames({ orderNumber, accessCode })
  console.log('Loaded order names', toRaw(names.value))
}

export const clearOrder = () => {
  names.value = null
}

export const hasOrder = () => length(names.value) > 0

export const confirmedOrder = computed(() =>
  names.value?.find(startsWith('ord-'))
)

export const dailyReports = computed(() =>
  names.value?.filter(startsWith('dcr-')) ?? []
)

export const dailyReportDate = name => {
  const date = flow(name, [split('.'), head, split('-'), last])
  return date.substring(0, 4) + '-' + date.substring(4, 6) + '-' + date.substring(6)
}

export const orderConclusion = computed(() =>
  names.value?.find(startsWith('ocr-'))
)

export const downloadFile = async ({ orderNumber, accessCode }, name) => {
  const prefix = orderDirectory({ orderNumber, accessCode })
  return await readFile(prefix + name)
}
